import bgTexture from '@assets/images/Hero/hero-bg.png'; // background image (same as about page bg)

const missionVision = [
  {
    title: 'Mission',
    body: 'To cater to the needs of Filipino security professionals and at-risk individuals seeking comfort and security in their ballistic protection, this technology provides enhanced protection capabilities through a lightweight, custom-fit design tailored to the local physique.',
  },
  {
    title: 'Vision',
    body: 'A Filipino R&D-defense technology company creating cutting-edge, locally manufactured ballistic systems.',
  },
] as const;

export default function AboutMissionVision() {
  return (
    <section
      aria-labelledby="mission-vision-heading"
      className="
        relative isolate flex min-h-[672px] w-full items-center justify-center overflow-hidden
        bg-[#0B0B0B] px-4 py-12 text-white sm:px-6
      "
      style={{
        backgroundImage: `url(${bgTexture})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <h2 id="mission-vision-heading" className="sr-only">
        Our mission and vision
      </h2>

      <div aria-hidden="true" className="absolute inset-0 bg-black/30" />

      <div className="relative z-10 mx-auto grid w-full max-w-[1148px] grid-cols-1 gap-4 text-center sm:gap-6 lg:grid-cols-2">
        {missionVision.map(({ title, body }) => (
          <article
            key={title}
            className="flex min-h-[260px] flex-col justify-center bg-white/[0.19] px-7 py-10 backdrop-blur-[1px] sm:min-h-[300px] sm:px-10 lg:min-h-[310px]"
          >
            <h3 className="text-xl font-semibold leading-tight text-white">
              {title}
            </h3>
            <p className="mx-auto mt-5 max-w-[32rem] text-[13px] leading-[1.45] tracking-tight text-white/90 sm:text-sm">
              {body}
            </p>
          </article>
        ))}
      </div>
    </section>
  );
}
